import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";

import {
  Card,
  CardContent,
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { DRIVER_FORM_SUCCESS } from "navigation/CONSTANTS";
import { SET_EMPTY } from "../../config";
import { getDistricts, getUserName, saveWVForm } from "../../services/wvForms";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const KEY = "routeUpdates";

const useStyles = makeStyles((theme) => ({
  header: {
    border: `1px solid #dadce0`,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderRadius: 8,
    borderTopWidth: 10,
    borderTopColor: theme.palette.primary.main,
    marginTop: 10,
  },
  root: {
    minWidth: "80%",
  },
  form: {
    "&>*": {
      marginBottom: 16,
    },
  },
  textField: {
    minWidth: "50%",
  },
  textArea: {
    width: "100%",
  },
}));

const requestOptions = [
  { id: "1", value: "Item Count", label: "Item Count" },
  {
    id: "2",
    value: "Contact Information Update",
    label: "Contact Information Update",
  },
  { id: "3", value: "Business Hours", label: "Business Hours" },
  { id: "4", value: "Restrictions", label: "Restrictions" },
  {
    id: "5",
    value: "Special Client Instructions",
    label: "Special Client Instructions",
  },
  {
    id: "6",
    value: "Service Time Correction",
    label: "Service Time Correction",
  },
  { id: "7", value: "Other", label: "Other" },
];

function DriverForm() {
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles();

  const [empId, setEmpId] = useState(SET_EMPTY);
  const [empName, setEmpName] = useState(SET_EMPTY);
  const [routeID, setRouteId] = useState(SET_EMPTY);
  const [districts, setDistricts] = useState(SET_EMPTY);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [customerID, setCustomerId] = useState(SET_EMPTY);
  const [orderNo, setOrderNo] = useState(SET_EMPTY);
  const [request, setRequest] = useState(SET_EMPTY);
  const [visibleDetails, setVisibleDetails] = useState(false);
  const [details, setDetails] = useState(SET_EMPTY);
  const [description, setDescription] = useState(SET_EMPTY);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [empNameWarning, setEmpNameWarning] = useState(false);
  const [empNameDisabled, setEmpNameDisabled] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleProcessingOpen = () => {
    setProcessing(true);
  };

  const handleProcessingClose = () => {
    setProcessing(false);
  };

  useEffect(() => {
    getDistricts()
      .then((data) => {
        setDistrictOptions(data[0]);
        setLoading(false);
      })
      .catch((e) => {
        setDistrictOptions([]);
      });
  }, []);

  const getName = async (value) => {
    await getUserName(value)
      .then((data) => {
        if(data){
          setEmpName(data);
          setEmpNameWarning(false);
          setEmpNameDisabled(true);
        }
        else {
          setEmpName(SET_EMPTY);
          setEmpNameWarning(true);
          setEmpNameDisabled(false);
        }
        }
      )
      .catch((e) => {
        console.log("ERROR IN GET NAME" + e);
      });    
  };

  const handleEmpIdChange = (event) => {
    let value = event.target.value;
    setEmpId(value);
    if (value && value.length > 5) {
      getName(value);
    }else if(value && value.length>=0){
      setEmpName(SET_EMPTY);
      setEmpNameWarning(true);
      setEmpNameDisabled(false);
    }
    // else if (value && value.length > 0) setEmpNameWarning(false);
  };

  const handleEmpNameChange = (event) => {
    let value =event.target.value;
    setEmpName(value);
  }

  const handleRouteID = (event) => {
    let value = event.target.value;
    setRouteId(value);
  };

  const handleDistricts = (event, newValue) => {
    setDistricts(newValue);
  };

  const handleCustomerID = (event) => {
    let value = event.target.value;
    setCustomerId(value);
  };

  const handleOrderNo = (event) => {
    let value = event.target.value;
    setOrderNo(value);
  };

  const handleRequest = (event) => {
    let selectedOption = event.target.value;
    setRequest(selectedOption);
    if (selectedOption === "Other") {
      setVisibleDetails(true);
    } else {
      setVisibleDetails(false);
      setDetails(SET_EMPTY);
    }
  };

  const handleDetails = (event) => {
    let value = event.target.value;
    setDetails(value);
  };

  const handleDescription = (event) => {
    let value = event.target.value;
    setDescription(value);
  };

  const getTeamfromRequestType =(reqType)=>{

    if(!reqType) return [];

    if(reqType==='Contact Information Update' ||
    reqType ==='Item Count' || 
    reqType ==='Special Client Instructions'){
      return ['CS'];
    }else if(reqType ==='Business Hours' ||
    reqType ==='Restrictions' ||
    reqType ==='Service Time Correction'){
      return ['RPL'];
    }else {
      return ['CS','RPL'];
    }

  }

  const onSubmit = async () => {
    let form = {
      key: KEY,
      empId: empId.trim(),
      empName: empName.trim(),
      routeID: routeID.trim(),
      districts: districts.trim(),
      customerID: customerID.trim(),
      orderNo: orderNo.trim(),
      request: request.trim(),
      details: details.trim(),
      description: description.trim(),
    };

    handleProcessingOpen();
    form.team = getTeamfromRequestType(form.request);
    try {
      let driverFormID = await saveWVForm(form);
      console.log(`
        driver-form 
        driverFormID is ${driverFormID}
      `);
      handleProcessingClose();
      history.push(DRIVER_FORM_SUCCESS);
    } catch (error) {
      console.log(`
      driver-form 
      error is ${error}
     `);
    }
  };

  const onClear = () => {
    setEmpId(SET_EMPTY);
    setEmpName(SET_EMPTY);
    setRouteId(SET_EMPTY);
    setDistricts(SET_EMPTY);
    setCustomerId(SET_EMPTY);
    setOrderNo(SET_EMPTY);
    setRequest(SET_EMPTY);
    setVisibleDetails(false);
    setDetails(SET_EMPTY);
    setDescription(SET_EMPTY);
  };

  useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnv = document.querySelector(".imtime-testEnvironment");
    if (header) header.style.display = "none";
    if (testEnv) testEnv.style.display = "none";
  }, []);

  useEffect(() => {
    if (
      empId.length === 0 ||
      empName.length === 0 ||
      routeID.length === 0 ||
      orderNo.length === 0 ||
      districts.length === 0 ||
      customerID.length === 0 ||
      request.length === 0 ||
      description.length === 0
    ) {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
      if (visibleDetails && details.length === 0) {
        setIsSubmitDisabled(true);
      } else {
        setIsSubmitDisabled(false);
      }
    }
  }, [empId, empName, routeID,districts,customerID, orderNo, request, details, description, visibleDetails]);

  return (
    <>
      <Container maxWidth="sm">
        <form className={classes.form} noValidate autoComplete="off">
          <Grid container direction="column" alignItems="stretch" spacing={2}>
            <Grid item>
              <Card className={classes.header}>
                <CardContent>
                  <Typography variant="h6" gutterBottom color="textPrimary">
                    Account Update
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    This form should be used to:
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    - Adjust stop time
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    - Adjust client service time
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    - Correct number of items on client account
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    - Update Contact Information
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    - Special client instruction
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    Employee ID 
                    <span style={{color:"red"}}>*</span>
                  </Typography>
                  <TextField
                    value={empId}
                    onChange={handleEmpIdChange}
                    id="empId"
                    label="Enter Employee ID"
                    className={classes.textField}
                  />
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    Employee Name 
                    <span style={{color:"red"}}>*</span>
                  </Typography>
                  <TextField
                    value={empName}
                    onChange={handleEmpNameChange}
                    id="empName"
                    label="Enter Employee Name"
                    className={classes.textField}
                    disabled={empNameDisabled}
                    helperText={empNameWarning && "Worker not found"}
                  />
                </CardContent>
              </Card>
            </Grid>


            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    District ID 
                    <span style={{color:"red"}}>*</span>
                  </Typography>
                  <Autocomplete
                    id="districts"
                    type="dropdown"
                    style={{ width: 260 }}
                    className={classes.textField}
                    options={districtOptions}
                    getOptionLabel={(option) => option}
                    value={districts}
                    onChange={handleDistricts}
                    renderInput={(params) => (
                      <TextField {...params}
                      label="Select District ID" />
                    )}
                   />
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    Route ID# <span style={{color:"red"}}>*</span>
                  </Typography>
                  <TextField
                    id="routeID"
                    label="Enter Route ID"
                    className={classes.textField}
                    value={routeID}
                    onChange={handleRouteID}
                  />
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    Customer ID/Ship To Code <span style={{color:"red"}}>*</span>
                  </Typography>
                  <TextField
                    id="customerID"
                    label="Enter Customer ID"
                    className={classes.textField}
                    value={customerID}
                    onChange={handleCustomerID}
                  />
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    Order Number 
                    <span style={{color:"red"}}>*</span>
                  </Typography>
                  <TextField
                    id="orderNo"
                    label="Enter Order No"
                    className={classes.textField}
                    value={orderNo}
                    onChange={handleOrderNo}
                  />
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    What are you requesting? 
                    <span style={{color:"red"}}>*</span>
                  </Typography>
                  <RadioGroup
                    aria-label="gender"
                    name="gender1"
                    value={request}
                    onChange={handleRequest}
                  >
                    {requestOptions.map((option) => (
                      <FormControlLabel
                        key={option.id}
                        value={option.value}
                        control={<Radio />}
                        label={option.label}
                      ></FormControlLabel>
                    ))}
                  </RadioGroup>

                  {visibleDetails && (
                    <TextField
                      id="details"
                      label="Your Answer"
                      className={classes.textArea}
                      value={details}
                      onChange={handleDetails}
                    />
                  )}
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    Brief Description of submission 
                    <span style={{color:"red"}}>*</span>
                  </Typography>
                  <TextField
                    id="description"
                    label="Your Answer"
                    className={classes.textArea}
                    multiline={true}
                    value={description}
                    onChange={handleDescription}
                  />
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Grid container direction="row" justify="flex-end" spacing={2}>
                <Grid item>
                  <Button
                    type="Button"
                    variant="text"
                    color="secondary"
                    onClick={onClear}
                  >
                    Clear Form
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={onSubmit}
                    disabled={isSubmitDisabled}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Container>

      {/* Dialog to show backend processing  */}
      <Dialog
        open={processing}
        onClose={handleProcessingClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="alert-dialog-title">Submitting</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please wait while we submit your form <br /> <br />
            <Grid container justify="center">
              <Grid item>
                <CircularProgress />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default DriverForm;
